import roh from 'typescript-fsa-reducers/dist/index.js';

type Paket = typeof import('typescript-fsa-reducers');

// Hier werden nur benannte Ausfuhren gebraucht; das Exportobjekt selbst ist
// bereits das Richtige, es fehlen lediglich die Namen.
const modul = roh as unknown as Paket;

export const reducerWithInitialState = modul.reducerWithInitialState;
export const reducerWithoutInitialState = modul.reducerWithoutInitialState;
export const upcastingReducer = modul.upcastingReducer;

export default modul;
